import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AccessControlInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.production)
      request=request.clone({
        setHeaders:{
          'RequestVerificationToken': (<HTMLInputElement>document.getElementById("__RequestVerificationToken")).value        
      }});
     return next.handle(request);
  }
}
